import { Box, Heading, Text } from "@vinomofo/components";

import { usePlanContext } from "../../hooks/wine-clubs/use-plan-context";
import { SelectorOption } from "./SelectorOption";

const Label = ({ text }: { text: string }) => {
  return (
    <Text
      as="span"
      textTransform="uppercase"
      color="white"
      fontSize="14px"
      lineHeight="none"
    >
      {text}
    </Text>
  );
};

export const VariantSelector = (): JSX.Element => {
  const {
    variant: selectedVariant,
    variantOptions,
    changeVariant,
    changePreference,
    club,
  } = usePlanContext();

  if (!variantOptions) return null;

  return (
    <Box>
      <Box textAlign="center" mb={4}>
        <Heading as="h3" variant="sm" textAlign="center" color={"white"}>
          Pick your case
        </Heading>
      </Box>
      <Box display="flex">
        {variantOptions.map((variant, index) => {
          const defaultPreference = variant.preferences.find(
            (preference) => preference.key === "standard"
          );

          return (
            <SelectorOption
              key={index}
              onClick={() => {
                changeVariant(variant);
                if (defaultPreference) changePreference(defaultPreference);
              }}
              isSelected={variant === selectedVariant}
              activeColor={club.color}
            >
              <Label text={variant.label} />
              <Heading
                as="div"
                fontWeight={600}
                variant="lg"
                textAlign="center"
                color="white"
              >
                <Box display="flex">
                  <Box display="flex" mr="5px">
                    <Text as="span" fontFamily="heading" color="inherit">
                      $
                    </Text>
                    {variant.price}
                  </Box>
                </Box>
              </Heading>
              <Label text="Per case" />
            </SelectorOption>
          );
        })}
      </Box>
    </Box>
  );
};
